export default __webpack_public_path__ + "static/media/danger.d0cb1355.svg";